<app-features *ngIf="english"></app-features>
<app-features-hindi *ngIf="hindi"></app-features-hindi>